/** Fires `onboarding` when the user starts the post-registration onboarding flow. */
export const trackOnboarding = (content) => {
	const params = {
		game_name: content.game_name,
	}
	LuckyWiseAnalytics.click('onboarding', params)
}

/** Fires `skip_onboarding` when the user skips the onboarding flow. */
export const trackSkipOnboarding = (content) => {
	const params = {
		game_name: content.game_name,
		step_id: content.step_id,
	}
	LuckyWiseAnalytics.click('skip_onboarding', params)
}

/** Fires `ongoing_onboarding` when the user advances to the next onboarding step. */
export const trackOngoingOnboarding = (content) => {
	const params = {
		game_name: content.game_name,
		step_id: content.step_id,
	}
	LuckyWiseAnalytics.click('ongoing_onboarding', params)
}

/** Fires `starts_tour` when the user begins the results-page guided tour. */
export const trackStartsTour = (content) => {
	const params = {
		game_name: content.game_name,
		step_id: content.step_id,
	}
	LuckyWiseAnalytics.click('starts_tour', params)
}

/** Fires `skip_tour` when the user dismisses the guided tour early. */
export const trackSkipTour = (content) => {
	const params = {
		game_name: content.game_name,
		step_id: content.step_id,
	}
	LuckyWiseAnalytics.click('skip_tour', params)
}

/** Fires `onboarding_completed` when the user finishes all tour steps. */
export const trackOnboardingCompleted = (content) => {
	const params = {
		game_name: content.game_name,
		step_id: content.step_id,
	}
	LuckyWiseAnalytics.click('onboarding_completed', params)
}

/** Fires `ongoing_tour` when the user advances to the next tour step. */
export const trackOngoingTour = (content) => {
	const params = {
		game_name: content.game_name,
		step_id: content.step_id,
	}
	LuckyWiseAnalytics.click('ongoing_tour', params)
}
